module.exports = __webpack_public_path__ + "static/DWI20_Reg_1700x1200_Mosel-b2c940826df27bf7d809acc1718b63a5.jpeg";